import { isAuthGuard } from '@auth/guards/is-auth.guard';
import { hasRoleListGuard } from '@auth/guards/has-role-list.guard';
import { hasSelectedRoleGuard } from '@auth/guards/has-selected-role.guard';
import { hasRoleGuard } from '@auth/guards/has-role.guard';
import { Role } from '@shared/enums/role.enum';
import { AppRoutes } from '@core/interfaces/app-routes.interface';
import { chainCanActivateFns } from '@core/utils/chain-can-active-fns.util';

export const APP_ROUTES: AppRoutes = [
  {
    path: '',
    redirectTo: '/login/sso',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import('./auth.routes'),
  },
  {
    path: 'dashboard',
    canActivate: [chainCanActivateFns(isAuthGuard, hasRoleListGuard, hasSelectedRoleGuard)],
    loadComponent: () => import('@shared/components/drawer-menu/drawer-menu.component'),
    children: [
      {
        path: '',
        canActivate: [hasRoleGuard],
        data: { roles: [Role.Admin, Role.LimitedAdmin] },
        loadChildren: () => import('./admin.routes'),
      },
      {
        path: '',
        canActivate: [hasRoleGuard],
        data: { roles: [Role.FullContractor] },
        loadChildren: () => import('./contractor.routes'),
      },
    ],
  },
  // Wildcard for non-matching routes
  {
    path: '**',
    redirectTo: '/login/sso',
  },
];
